<template>
  <main class="fm-main">
    <div class="fm-page fm-page--narrow">
      <div class="fm-page-head">
        <div class="fm-page-title">Account</div>
      </div>
      <div class="fm-page-desc">Your identity, credentials, and active sessions.</div>
      <user-card></user-card>
    </div>
  </main>
</template>
<script>
import UserCard from './UserProfile/UserCard.vue'

export default {
  components: {
    UserCard
  }
}
</script>
